export default __webpack_public_path__ + "static/media/icon-business-model-commission.52cec528.svg";